
export class EnregistrementInventaire {

    id: number;
    designation: number;
    stockinitial: number;
    entreesdujour: number;
    sortiesdujour: number;
    stocktheo: number;
    stockreel: number;
    prixachat: number;


    constructor() {

        // super();
        // this.montant = 0;
    }

    get ecart(): number {

        if ( this.stockreel === undefined || this.stockreel === null)
        this.stockreel = 0;

        return this.stockreel - this.stocktheo;

    }

    get valorisationStockTheo(): number {

        if ( this.stocktheo === undefined || this.stocktheo === null)
        this.stocktheo = 0;

        return this.stocktheo * this.prixachat;

    }

    get valorisationStockReel(): number {

        if ( this.stockreel === undefined || this.stockreel === null)
        this.stockreel = 0;

        return this.stockreel * this.prixachat;

    }

    get valorisationEcart(): number {

        return this.ecart * this.prixachat;
    }


}
